export default __webpack_public_path__ + "static/media/DDD-Clinics.b622d894.png";